"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../gen-src/Localize");
exports.overLimitCounter = {
    color: widgets_1.TabStyles.Colors.AttentionLight
};
function CharacterCounter(props) {
    var tooLong = props.value.length > props.maximum;
    var style = tooLong ? __assign({}, exports.overLimitCounter) : {};
    if (!!props.styleOverride) {
        style = __assign({}, style, props.styleOverride);
    }
    return (React.createElement("div", { style: style }, Localize_1.Messages.CharacterCounter({
        COUNT_LOC: Localize_1.Formatters.formatCount(props.value.length),
        MAXIMUM_LOC: Localize_1.Formatters.formatCount(props.maximum)
    })));
}
exports.CharacterCounter = CharacterCounter;
//# sourceMappingURL=CharacterCounter.js.map